export class ListItemsSetLoadingAction {
  constructor(public loading: boolean = true) {}
}
